import { createContext, useContext } from 'react'
import { LOCAL_STORAGE_KEY } from './constants'
import { RootStateModel, RootStateModelType } from './models'
import { BLHUser } from '../dme.types'

let initialState = RootStateModel.create()

const RootStoreContext = createContext<null | RootStateModelType>(null)

export function useDMEStore(): RootStateModelType {
  const store = useContext(RootStoreContext)

  if (store === null) {
    throw new Error('Store cannot be null, please add a context provider')
  }

  return store
}

if (typeof window !== 'undefined') {
  const data = localStorage.getItem(LOCAL_STORAGE_KEY)

  if (data) {
    const json = JSON.parse(data)

    if (RootStateModel.is(json)) {
      initialState = RootStateModel.create(json as any)
    }
  }
}

export const DMEStoreProvider = RootStoreContext.Provider
export const rootStore = initialState
export const createRootStore = (user?: BLHUser) => {
  if (user) {
    initialState.user.update({
      ...initialState.user,
      email: user.email,
      id: user.id,
    })
  }

  return initialState
}
export * from './models'
